import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap5';
import * as Yup from 'yup';
import { Formik, Form as FormikForm } from 'formik';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import Modal from 'components/new_ui/Modal/Modal';
import HorizontalTextField from 'components/new_ui/Form/HorizontalTextField';
import HorizontalSelectField from 'components/new_ui/Form/HorizontalSelectField';
import useCountries from 'components/Common/Countries/Hooks/useCountries';
import { useContext } from 'components/Managers/Billing/Context';

export default function Form({ show, onHide, initValue }) {
  const { dispatch, actions } = useContext();
  const { countries } = useCountries();

  const formSchema = Yup.object().shape({
    name: Yup.string().required('Note is required'),
    email: Yup.string().required('Email is required'),
  });

  const onSubmit = (values, { setSubmitting, setErrors }) => {
    actions.savePaymentMethod(
      dispatch,
      initValue.id,
      values,
      () => {
        setSubmitting(false);
        onHide();
      },
      (errorData) => {
        const newErrors = {};
        errorData.errors.forEach((item) => {
          newErrors[item.source.pointer.replace('/data/attributes/', '')] = item.detail;
        });
        setErrors(newErrors);
        setSubmitting(false);
      },
    );
  };

  return (
    <Modal show={show}>
      <Formik
        validationSchema={formSchema}
        initialValues={{
          name: initValue.attributes.name,
          email: initValue.attributes.email,
          country: initValue.attributes.country,
          city: initValue.attributes.city,
          address_line1: initValue.attributes.address_line1,
          address_line2: initValue.attributes.address_line2,
          postal_code: initValue.attributes.postal_code,
          invoice_footer: initValue.attributes.invoice_footer,
          invoice_memo: initValue.attributes.invoice_memo,
        }}
        onSubmit={onSubmit}
      >
        {({ isSubmitting }) => (
          <FormikForm className="needs-validation" noValidate="">
            <HorizontalTextField name="name" label="Bill To" required />
            <HorizontalTextField name="email" type="email" label="Email" required />
            <HorizontalSelectField
              name="country"
              label="Country"
              placeholder={countries === null ? 'Loading...' : 'Select Country'}
              options={countries === null ? [] : countries}
            />
            <HorizontalTextField name="city" label="City" />
            <HorizontalTextField name="address_line1" label="Address Line 1" />
            <HorizontalTextField name="address_line2" label="Address Line 2" />
            <HorizontalTextField name="postal_code" label="Postal Code" />
            <HorizontalTextField name="invoice_memo" as="textarea" label="Invoice Memo" />
            <HorizontalTextField name="invoice_footer" as="textarea" label="Invoice Footer" />

            <footer>
              <Button
                variant="outline-primary"
                disabled={isSubmitting}
                onClick={onHide}
              >
                Cancel
              </Button>

              <Button
                type="submit"
                disabled={isSubmitting}
              >
                {isSubmitting && (
                  <LoadingPlaceholder placement="inline" text=" " />
                )}
                Save
              </Button>
            </footer>
          </FormikForm>
        )}
      </Formik>
    </Modal>
  );
}

Form.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  initValue: PropTypes.object.isRequired,
};
